'use client'

import ReactQueryProvider from '@/globals/providers/ReactQueryProvider'
import { ReactNode } from 'react'

/**
 * 공개 페이지용 Provider
 * - ClerkProvider 없이 동작 (인증 불필요)
 * - React Query만 제공
 * - 박람회/전시회 키오스크 환경에서 사용
 */
export function PublicProviders({ children }: { children: ReactNode }) {
  return (
    <ReactQueryProvider>
      {children}
    </ReactQueryProvider>
  )
}
